import React, { useState } from 'react';
import { Page } from '../types';
import ImageViewer from './ImageViewer';
import { env } from 'process';

interface GenericPageProps {
  page: Page;
}

const GenericPage: React.FC<GenericPageProps> = ({ page }) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // Simple sanitizer to remove script tags and on* attributes
  const sanitizeHTML = (html: string) => {
    if (typeof DOMParser === 'undefined') {
      return html;
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('script, style').forEach(el => el.remove());

    doc.querySelectorAll('*').forEach(el => {
      for (const attr of Array.from(el.attributes)) {
        if (attr.name.startsWith('on')) {
          el.removeAttribute(attr.name);
        }
      }
    });

    return doc.body.innerHTML;
  };

  const safeContent = page.content ? sanitizeHTML(page.content) : '';

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'IMG') {
      const img = target as HTMLImageElement;
      e.preventDefault();
      setSelectedImage(img.src);
    }
  };

  return (
    <div className="rounded-lg shadow-2xl border-1 border-gray-200 p-6 md:p-8"
         style={{ marginBottom: "calc(3rem + env(safe-area-inset-bottom, 0px))" }}
    >
      <div
        className="prose prose-sm md:prose-base lg:prose-lg max-w-none prose-headings:text-gray-800 prose-p:text-gray-600 prose-a:text-pink-600 prose-strong:text-gray-700 prose-img:rounded-lg prose-img:cursor-zoom-in prose-img:transition-transform prose-img:hover:scale-[1.01]"
        dangerouslySetInnerHTML={{ __html: safeContent }}
        onClick={handleContentClick}
      />

      {selectedImage && (
        <ImageViewer
          src={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </div>
  );
};

export default GenericPage;
